import { useState } from "react";
import { NavLink } from "react-router-dom";

import iowtLogo from '../../images/iowt_icon.png';
import gtLogo from "../../images/gatech_logo.png";
import AskUsButton from '../AskUsButton/AskUsButton.jsx';
import DarkModeToggle from './DarkModeToggle/DarkModeToggle.jsx';
import StudyProgressBar from "./StudyProgressBar/StudyProgressBar.jsx";
import CookieConsent from "./CookieConsent/CookieConsent.jsx";
import MouseHoverInfoTooltip from "../StudyOneInstructions/MouseHoverInfoTooltip.jsx";
import Loader from "./Loader/Loader.jsx";
import Cookies from 'js-cookie';
import { motion } from "framer-motion";
import "./NavBar.css";

export default function NavBar({ enableCombinedExperience, enableDarkModetoggle }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleNavMenu = () => setIsMenuOpen(!isMenuOpen);
    const firstName = Cookies.get('firstname');

    return (
        <>
            <header>
                <a href="#askUsButton" className="skip-link">Skip to main content</a>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/boxicons@latest/css/boxicons.min.css" />
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous"></link>
                <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz" crossOrigin="anonymous"></script>

                <nav className={`navbar ${isMenuOpen ? "navbar-open" : ""}`}>
                    <div className="logo-text">
                        <span className="logo"><img src={gtLogo} alt="GaTech" /></span>
                        <span className="text">X</span>
                        <span className="logo"><img src={iowtLogo} alt="IoWT" /></span>

                        <a className="text branding-text" href="/home">EmoAI</a>
                        
                        <Loader />
                    </div>

                    <button className="button menu-toggle" onClick={toggleNavMenu}>{isMenuOpen ? '◀' : '▶'}</button>

                    <div className="menu">
                        <ul>
                            <motion.li
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                            >
                                <NavBarLink url="/intro" iconClass="bx bx-chalkboard icon bx-tada-hover" 
                                    iconTitle="EmoAI Intro" iconText="EmoAI Intro"
                                />
                            </motion.li>
                            <motion.li
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                            >
                                <NavBarLink url="/explore" iconClass="bx bx-task icon bx-tada-hover" 
                                    iconTitle="Exploration" iconText="Exploration"
                                />
                            </motion.li>
                            <motion.li
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                            >
                                <NavBarLink url="/discussion" iconClass="bx bx-chalkboard bx-flip-horizontal icon bx-tada-hover" 
                                    iconTitle="Discussion" iconText="Discussion"
                                />
                            </motion.li>
                            {/* <motion.li
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                            >
                                <NavBarLink url="/explore" iconClass="bx bx-task icon bx-tada-hover" 
                                    iconTitle="Study Two" iconText="Phase Two"
                                />
                            </motion.li> */}
                            {enableDarkModetoggle && 
                                <motion.li
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.8 }}
                                >
                                    <DarkModeToggle />
                                </motion.li>
                            }
                            <motion.li>
                                {enableCombinedExperience ? 
                                    <MouseHoverInfoTooltip
                                        displayComponent={
                                            <i className="bx bx-user-pin icon" style={{fontSize:"2.5rem", paddingTop: "0.5rem"}} />
                                        }
                                        headerComponent={firstName ? `Welcome ${firstName}!` : 'Welcome, please login!'}
                                        tooltipPlacement={'bottom'}
                                        tooltipComponent={
                                            <li>
                                                <NavBarLink url="/login_register" iconClass="bx bx-user-check icon bx-tada-hover" 
                                                    iconTitle="Login / Register" iconText="Login / Register"
                                                />
                                                <NavBarLink url="/logout" iconClass="bx bx-user-x icon bx-tada-hover" 
                                                    iconTitle="Logout" iconText="Logout"
                                                />
                                            </li>
                                        }
                                    />
                                :
                                    <NavBarLink url="/login_register" iconClass="bx bx-user icon bx-tada-hover" 
                                        iconTitle="Login / Register" iconText="Login / Register"
                                    />
                                }
                            </motion.li>
                        </ul>
                    </div>
                </nav>
            </header>
            {/* <AskUsButton /> */}
            <StudyProgressBar />
            <CookieConsent />

        </>
    );
}

function NavBarLink(props) {
    return (
        <NavLink to={props.url}>
            <i className={props.iconClass} title={props.iconTitle} style={{fontSize:"1.5rem"}}/>
            <span className="text">{props.iconText}</span>
        </NavLink>
    );
}
